import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

import TopBar from './TopBar';
import Footer from './Footer';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0
  },
  content: {
    paddingTop: theme.spacing(8),
    overflow: 'auto',
  },

  form: {
    width: '50%'
  }
}));

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <div>
      <TopBar />
      <div className={classes.content}>{children}</div>
      <Footer />
    </div>
  );
};

export default AppLayout;
